// export default {
//     BACKEND_URL: "http://localhost:4000",
//     FRONTEND_URL: "http://localhost:3000",
// }

export default {
    BACKEND_URL: "https://api.joyfullminds.com",
    FRONTEND_URL: "https://joyfullminds.com",
}